import {Component, Input, OnInit} from '@angular/core';
import {
  PaymentRequestSummaryModel
} from '../../../../../sale/modules/payment_request/api/entity/paymentRequestSummary.model';
import {
  PaymentRequestDeleteAllMovementsService
} from '../../../../../sale/modules/payment_request/api/service/PaymentRequestDeleteAllMovements.service';
import {BaseView} from '../../../../../core/view/base.view';
import {ChargedActRepository} from '../../service/ngrx/chargedAct.repository';
import {ChargedActModel} from '../../../api/entity/chargedAct.model';

@Component({
  selector: 'app-charged-act-summary-paid-payment-request',
  templateUrl: './charged-act-summary-paid-payment-request.component.html',
  providers: [
    PaymentRequestDeleteAllMovementsService,
  ]
})
export class ChargedActSummaryPaidPaymentRequestComponent extends BaseView implements OnInit {

  @Input() chargedAct: ChargedActModel;
  @Input() paymentRequest: PaymentRequestSummaryModel;
  constructor(public service: PaymentRequestDeleteAllMovementsService,
              public chargedActRepository: ChargedActRepository) {
    super();
  }

  ngOnInit(): void {
  }

  removeAllMovements() {
    this.service.executeAction({
      id: this.paymentRequest.id
    }).then(() => {
      this.toastControl.presentConfirmation('Suppression effectuée');
      this.chargedActRepository.updated(this.chargedAct);
    })
        .catch((e) => this.toastControl.presentError(e));
  }

}
